import API from "../../api";
import { API_USER_MASTER, API_USER_MASTER_UPDATE_BATCH, API_USER_MASTER_CHANGE_PASSWORD, API_USER_MASTER_RESET_PASSWORD } from "../../constants/api";

// call api user list
const fetchUsers = async () => {
  try {
    const response = await API.get(API_USER_MASTER);
    return response.data;
  } catch (e) {
    throw e.response;
  }
};

const createUser = async (data) => {
  try {
    const response = await API.post(API_USER_MASTER, data);
    return response.data;
  } catch (e) {
    throw e.response
  }
};

const updateUser = async (userData, deletedUserIds) => {
  const payload = {
    users: userData,
    delete_user_ids: deletedUserIds
  };
  const headers = {
    'Content-Type': 'application/json'
  };
  try {
    const response = await API.post(API_USER_MASTER_UPDATE_BATCH, JSON.stringify(payload), {headers});
    return response.data;
  } catch (e) {
    throw e.response
  }
};

const changePassword = async(data) => {
  try {
    const response =  await API.post(API_USER_MASTER_CHANGE_PASSWORD, data);
    return response.data;
  } catch (e) {
    throw e.response
  }
};

const resetPassword = async(data) => {
  try {
    const response =  await API.post(API_USER_MASTER_RESET_PASSWORD, data);
    return response.data;
  } catch (e) {
    throw e.response
  }
};

const UserServices = {
  fetchUsers,
  createUser,
  changePassword,
  updateUser,
  resetPassword
};

export {
  UserServices as default,
  fetchUsers,
  createUser,
  changePassword,
  updateUser,
  resetPassword
}